import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { STORE } from '@/core/store/core.store';
import { WidgetStudentCourse } from '@/homework/models/widget-student-course.model';
import EdHomeworkStudentSectionItem from '@/homework/component/ed-homework-student-section-item/ed-homework-student-section-item.vue';
import {HOMEWORKS_EVENTS} from '@/homework/values/homeworks.values';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';

@Component({
  components: {
    EdHomeworkStudentSectionItem
  }
})
export default class EdCourse extends Vue {
  
  /* Arguments */
  @Prop() readonly course: WidgetStudentCourse;

  /* Data */
  public isLoading: boolean = false;
  public showHomeworks: boolean = false;
  public firstLoad: boolean = false;

  /* Computed */
  get showSeeMore(): boolean {
    return this.course.sections.more;
  }

  get page(): number {
    return this.course.sections.page;
  }

  get homeworks() {
    return this.course.sections.content;
  }

  /* Method */
  public async getHomeworks(refresh?: boolean): Promise<boolean>{
    this.isLoading = true;
    if(refresh) {
      this.course.sections.page = 0;
    }
    let copyCourse = {...this.course};

    this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.GET_STUDENT_PENDING_HOMEWORKS, {course: copyCourse, refresh: refresh}).finally(() => {
      this.isLoading = false;
      this.firstLoad = true;
    });
    return true;
  }

  public getMoreHomeworks(emitScreenMirroringEvent: boolean = true): void {
    this.getHomeworks();

    if(emitScreenMirroringEvent) {
      let target = this.target(SCREEN_MIRRORING_EVENTS.ON_GET_MORE_HOMEWORKS);
      this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:target});
    }
  }

  public getMoreHomeworksWithAutoScrolling() {
    this.getMoreHomeworks(false);
    let links = this.$el.getElementsByClassName('ed-link--see-more');
    if( links.length > 0 ) {
      links[0].scrollIntoView();
    }
  }

  public loadHomeworksOnce(): void {
    if(!this.firstLoad) {
      this.getHomeworks();
    }
  }

  public reloadHomeworks(data): void {
    if(this.course.classId === data.classId && this.course.id === data.courseId) {
      this.getHomeworks(true);
    }
  }

  openCourse(emitScreenMirroringEvent:boolean=true) {
    this.showHomeworks = !this.showHomeworks;

    if( emitScreenMirroringEvent ) {
      let target = this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_COURSE);
      this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:target, showHomeworks: this.showHomeworks});
    }
  }

  openCourseWithAutoScrolling({showHomeworks} : {showHomeworks:boolean}) {
    this.openCourse(false);
    this.loadHomeworksOnce();
    this.$el.scrollIntoView();
    this.showHomeworks = showHomeworks;
  }

  reloadHomeworkListAfterReconnection() {
    this.showHomeworks = false;
    if( this.firstLoad ) {
      this.getHomeworks(true);
    }
  }

  target(screenMirroringEventName:string) {
    let courseId = this.course.id.toString();
    let classId = this.course.classId.toString();
    return screenMirroringEventName.replace('{courseId}',courseId).replace('{classId}',classId);
  }

  created(): void {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.WHITEBOARD_CLOSED_ON_DELETE, this.reloadHomeworks);
    this.$edEventBus.$on(COURSES_EVENTS.REFRESH_ON_SECTION_UPDATED, this.reloadHomeworks);
    this.$edEventBus.$on(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_COURSE), this.openCourseWithAutoScrolling);
    this.$edEventBus.$on(this.target(SCREEN_MIRRORING_EVENTS.ON_GET_MORE_HOMEWORKS), this.getMoreHomeworksWithAutoScrolling);
    this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.ON_WSSOCKET_RECONNECTION, this.reloadHomeworkListAfterReconnection);
  }

  beforeDestroy(): void {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.WHITEBOARD_CLOSED_ON_DELETE, this.reloadHomeworks);
    this.$edEventBus.$off(COURSES_EVENTS.REFRESH_ON_SECTION_UPDATED, this.reloadHomeworks);
    this.$edEventBus.$off(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_COURSE));
    this.$edEventBus.$off(this.target(SCREEN_MIRRORING_EVENTS.ON_GET_MORE_HOMEWORKS));
    this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.ON_WSSOCKET_RECONNECTION, this.reloadHomeworkListAfterReconnection);
  }

} 